import Arrow from './types/arrow'
import ArrowReverse from './types/arrow-reverse'
import ArrowAlt from './types/arrow-alt'
import ArrowAltReverse from './types/arrow-alt-reverse'
import ArrowTurn from './types/arrow-turn'
import ArrowTurnReverse from './types/arrow-turn-reverse'
import Boring from './types/boring'
import Collapse from './types/collapse'
import CollapseReverse from './types/collapse-reverse'
import Elastic from './types/elastic'
import ElasticReverse from './types/elastic-reverse'
import Emphatic from './types/emphatic'
import Minus from './types/minus'
import PerspectiveX from './types/perspective-x'
import PerspectiveXReverse from './types/perspective-x-reverse'
import PerspectiveY from './types/perspective-y'
import PerspectiveYReverse from './types/perspective-y-reverse'
import PerspectiveXY from './types/perspective-x-y'
import PerspectiveXYReverse from './types/perspective-x-y-reverse'
import Slider from './types/slider'
import SliderReverse from './types/slider-reverse'
import Spin from './types/spin'
import SpinReverse from './types/spin-reverse'
import Spring from './types/spring'
import SpringReverse from './types/spring-reverse'
import Squeeze from './types/squeeze'
import Stand from './types/stand'
import StandReverse from './types/stand-reverse'
import Vortex from './types/vortex'
import VortexReverse from './types/vortex-reverse'

module.exports = {
	Arrow,
	ArrowReverse,
	ArrowAlt,
	ArrowAltReverse,
	ArrowTurn,
	ArrowTurnReverse,
	Boring,
	Collapse,
	CollapseReverse,
	Elastic,
	ElasticReverse,
	Emphatic,
	Minus,
	PerspectiveX,
	PerspectiveXReverse,
	PerspectiveY,
	PerspectiveYReverse,
	PerspectiveXY,
	PerspectiveXYReverse,
	Slider,
	SliderReverse,
	Spin,
	SpinReverse,
	Spring,
	SpringReverse,
	Squeeze,
	Stand,
	StandReverse,
	Vortex,
	VortexReverse,
}